module.exports = __webpack_public_path__ + "components/flag/static/square/ms-9aa221d3539e779eabd81e6c0226e6be.svg";